module.exports = __webpack_public_path__ + "static/img/mb_trading_service_umy.7c58cf49.png";